import React from 'react';
import LastUpdated from './LastUpdated';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <LastUpdated filePath="Footer.js" />
        <p>
          <a href="/accessibility.html" title="Accessibility information">Accessibility</a>
          {' | '}
          <a href="/copyright.html" title="Copyright Information">Copyright Information</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

